import { Button, Modal } from "antd";
import { useState } from "react";
import { DsaScreenDto } from "../../generated/dashboard-client";
import DSAApi from "../../api/DSAApi";
import "./ConfirmationModal.scss";

export interface DisplayDiagnosticsOnScreenConfirmationModalProps {
  isVisible: boolean;
  onClose: (fetch: boolean) => void;
  active: DsaScreenDto;
}

export function DisplayDiagnosticsOnScreenConfirmationModal({isVisible, onClose, active}: DisplayDiagnosticsOnScreenConfirmationModalProps) {
  const [loading, setLoading] = useState(false);
  
  async function showDiagnostics() {
    if (!active.serial) return;
    setLoading(true);
    await DSAApi.sendDeviceCommand(active.serial, {command: 'player/diagnostics'});
    setLoading(false);
    onClose(false);
  }

  return (
    <Modal className={"confirmation-modal clean"} visible={isVisible} onCancel={() => onClose(false)}>
      <header>
        <h2>Display diagnostics on {active?.name}?</h2>
      </header>

      <footer>
        <Button size={"large"} onClick={() => onClose(false)}>Cancel</Button>
        <Button size={"large"} className={"primary"} onClick={showDiagnostics} loading={loading}>Show diagnostics</Button>
      </footer>
    </Modal>
  );
}
